<template>
  <v-layout justify-center>
    <v-flex>
      <panel :title="$t('companyDetails.createCompany')">
        <v-text-field
          :label="$t('companyGenerics.companyName')"
          required
          :rules="[required]"
          v-model="company.company_name"
        ></v-text-field>
        <v-text-field
          :label="$t('companyGenerics.companyDescr')"
          required
          :rules="[required]"
          v-model="company.description"
        ></v-text-field>
        <v-checkbox :label="$t('companyDetails.enabled')" v-model="company.enabled"></v-checkbox>
        <div class="danger-alert" v-if="error">{{error}}</div>
        <v-btn dark class="secondary" @click="create">{{$t('companyDetails.createCompany')}}</v-btn>
      </panel>
    </v-flex>
  </v-layout>
</template>

<script>
import CompaniesService from '@/services/CompaniesService';

export default {
  data() {
    return {
      company: {
        company_name: null,
        description: null,
        enabled: true,
      },
      error: null,
      required: value => !!value || value === 0 || 'Required.'
    };
  },
  methods: {
    async create() {
      this.error = null;
      try {
        await CompaniesService.post(this.company);
        this.$emit('close');
      } catch (err) {
        this.error = err.message || $t('mainErrors.somethingWrong');
        console.log(err);
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CreateCompany.vue